import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BlockingDialogComponent } from './blockingdialog.component';
import { CompletionDialogComponent } from './completion-dialog/completion-dialog.component';
import { ConfirmDialogComponent } from './confirmdialog.component';
import { ErrorDialogComponent } from './errordialog/errordialog.component';
import { InfoDialogComponent } from './infodialog.component';
import { MultiChoiceDialogComponent } from './multichoicedialog.component';
import { OrgBrainDialogService } from './orgbrainDialog.service';
import { ProgressDialogComponent } from './progressdialog.component';
import { WorkingDialogComponent } from './workingdialog.component';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { BlurOnInitDirective } from '../directives/blur.directive';
import { DialogTitleComponent } from '../style/dialog-title/dialog-title.component';
import { DeleteDialogComponent } from './deletedialog.component';
import { InfoBoxOpenButtonComponent } from './info-box/info-box-open-button.component';
import { InfoBoxComponent } from './info-box/info-box.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { SonnerComponent } from './sonner.component';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatTooltipModule,
    BlurOnInitDirective,
    MatTabsModule,
    MatProgressBarModule,
  ],
  declarations: [
    ProgressDialogComponent,
    ConfirmDialogComponent,
    CompletionDialogComponent,
    DeleteDialogComponent,
    InfoDialogComponent,
    BlockingDialogComponent,
    ErrorDialogComponent,
    SonnerComponent,
    MultiChoiceDialogComponent,
    WorkingDialogComponent,
    LoadingSpinnerComponent,
    DialogTitleComponent,
    InfoBoxComponent,
    InfoBoxOpenButtonComponent,
  ],
  exports: [
    LoadingSpinnerComponent,
    DialogTitleComponent,
    InfoBoxComponent,
    InfoBoxOpenButtonComponent,
  ],

  providers: [OrgBrainDialogService],
})
export class OrgBrainDialogsModule {}
export { MultiChoiceDialogComponent } from './multichoicedialog.component';
export { WorkingDialogComponent } from './workingdialog.component';
